import { AdminService } from 'app/API';
import { cancelOnSignal } from 'app/API/core/CancelablePromise';
import type { QueryFunctionContext } from '@tanstack/react-query';
import type { transactionsKeys } from 'app/queries/transactions/transactionsKeys';
import type { TCall } from 'app/queries/types/TCall';

type TParams = QueryFunctionContext<ReturnType<typeof transactionsKeys.list>>;

export const createFetchAdminTransactionsQueryFn =
  (call: TCall) =>
  ({ queryKey: [{ params }], signal }: TParams) =>
    call(() =>
      cancelOnSignal(
        AdminService.getTransactionsList({
          pageNo: params.page.toString(),
          pageSize: params.pageSize.toString(),
          orderBy: params.orderBy,
          orderType: params.orderType,
          search: params.search,
          from: params.from,
          to: params.to,
        }),
        signal,
      ),
    );
